export const CINEMA_RENT_INQUIRY_REQUEST_REQUEST = 'cinemaRent/CINEMA_RENT_INQUIRY_REQUEST_REQUEST';
export const CINEMA_RENT_INQUIRY_REQUEST_SUCCESS = 'cinemaRent/CINEMA_RENT_INQUIRY_REQUEST_SUCCESS';

export const CINEMA_RENT_REQUEST = 'cinemaRent/CINEMA_RENT_REQUEST';
export const CINEMA_RENT_SUCCESS = 'cinemaRent/CINEMA_RENT_SUCCESS';
